export class ExpertTime {
    id?: string;
    date_time: Date;
    time?: string;
    timeString?: string;
    row?: number;
}